var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRatifiedIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 6.5L9 4M9 4L6.5 1.5M9 4H6.5C3.73858 4 1.5 6.23858 1.5 9M21.5 21.5L19 24M19 24L21.5 26.5M19 24H21.5C24.2614 24 26.5 21.7614 26.5 19M15.7715 15.7715C16.7493 16.2385 17.8441 16.5 19 16.5C23.1421 16.5 26.5 13.1421 26.5 9C26.5 4.85786 23.1421 1.5 19 1.5C14.8579 1.5 11.5 4.85786 11.5 9C11.5 10.1559 11.7615 11.2507 12.2285 12.2285M16.5 19C16.5 23.1421 13.1421 26.5 9 26.5C4.85786 26.5 1.5 23.1421 1.5 19C1.5 14.8579 4.85786 11.5 9 11.5C13.1421 11.5 16.5 14.8579 16.5 19Z",
    stroke: "#4945FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRatifiedIcon);
export default __webpack_public_path__ + "static/media/ratified_icon.b02a33ba80f7c1f851908de4f6e3112b.svg";
export { ForwardRef as ReactComponent };